/**
 * Rocksoft In-Room Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { BaseDataResultApiModelListOfLightInfoApiModel } from '../model/baseDataResultApiModelListOfLightInfoApiModel';
// @ts-ignore
import { BaseDataResultApiModelOfLightSwitchApiModel } from '../model/baseDataResultApiModelOfLightSwitchApiModel';
// @ts-ignore
import { BaseDataResultApiModelOfListOfLightColorApiModel } from '../model/baseDataResultApiModelOfListOfLightColorApiModel';
// @ts-ignore
import { BaseDataResultApiModelOfListOfLightDimApiModel } from '../model/baseDataResultApiModelOfListOfLightDimApiModel';
// @ts-ignore
import { BaseDataResultApiModelOfListOfZoneApiModel } from '../model/baseDataResultApiModelOfListOfZoneApiModel';
// @ts-ignore
import { BaseResultApiModel } from '../model/baseResultApiModel';
// @ts-ignore
import { LightColorApiModel } from '../model/lightColorApiModel';
// @ts-ignore
import { LightDimApiModel } from '../model/lightDimApiModel';
// @ts-ignore
import { LightSwitchApiModel } from '../model/lightSwitchApiModel';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';


export interface SwitchRequestParams {
    hotelCode: string;
    room: string;
    lightSwitchApiModel?: LightSwitchApiModel;
}

export interface AllRequestParams {
    hotelCode: string;
    room: string;
}

export interface GetLightZonesRequestParams {
    hotelCode: string;
    room: string;
}

export interface GetcolorRequestParams {
    hotelCode: string;
    room: string;
    body?: string;
}

export interface GetdimRequestParams {
    hotelCode: string;
    room: string;
    body?: string;
}

export interface GetswitchstateRequestParams {
    hotelCode: string;
    room: string;
    body?: string;
}

export interface SetcolorRequestParams {
    hotelCode: string;
    room: string;
    lightColorApiModel?: LightColorApiModel;
}

export interface SetdimRequestParams {
    hotelCode: string;
    room: string;
    lightDimApiModel?: LightDimApiModel;
}


@Injectable({
  providedIn: 'root'
})
export class LightsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint post /{hotelCode}/ctrlapi/1/{room}/lights/switch
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public _switch(requestParameters: SwitchRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BaseResultApiModel>;
    public _switch(requestParameters: SwitchRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BaseResultApiModel>>;
    public _switch(requestParameters: SwitchRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BaseResultApiModel>>;
    public _switch(requestParameters: SwitchRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const hotelCode = requestParameters?.hotelCode;
        if (hotelCode === null || hotelCode === undefined) {
            throw new Error('Required parameter hotelCode was null or undefined when calling _switch.');
        }
        const room = requestParameters?.room;
        if (room === null || room === undefined) {
            throw new Error('Required parameter room was null or undefined when calling _switch.');
        }
        const lightSwitchApiModel = requestParameters?.lightSwitchApiModel;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (basic) required
        localVarHeaders = this.configuration.addCredentialToHeaders('basic', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/${this.configuration.encodeParam({name: "hotelCode", value: hotelCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ctrlapi/1/${this.configuration.encodeParam({name: "room", value: room, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/lights/switch`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BaseResultApiModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: lightSwitchApiModel,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /{hotelCode}/ctrlapi/1/{room}/lights/all
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public all(requestParameters: AllRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BaseDataResultApiModelListOfLightInfoApiModel>;
    public all(requestParameters: AllRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BaseDataResultApiModelListOfLightInfoApiModel>>;
    public all(requestParameters: AllRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BaseDataResultApiModelListOfLightInfoApiModel>>;
    public all(requestParameters: AllRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const hotelCode = requestParameters?.hotelCode;
        if (hotelCode === null || hotelCode === undefined) {
            throw new Error('Required parameter hotelCode was null or undefined when calling all.');
        }
        const room = requestParameters?.room;
        if (room === null || room === undefined) {
            throw new Error('Required parameter room was null or undefined when calling all.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (basic) required
        localVarHeaders = this.configuration.addCredentialToHeaders('basic', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/${this.configuration.encodeParam({name: "hotelCode", value: hotelCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ctrlapi/1/${this.configuration.encodeParam({name: "room", value: room, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/lights/all`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BaseDataResultApiModelListOfLightInfoApiModel>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /{hotelCode}/ctrlapi/1/{room}/lights/getzones
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getLightZones(requestParameters: GetLightZonesRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BaseDataResultApiModelOfListOfZoneApiModel>;
    public getLightZones(requestParameters: GetLightZonesRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BaseDataResultApiModelOfListOfZoneApiModel>>;
    public getLightZones(requestParameters: GetLightZonesRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BaseDataResultApiModelOfListOfZoneApiModel>>;
    public getLightZones(requestParameters: GetLightZonesRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const hotelCode = requestParameters?.hotelCode;
        if (hotelCode === null || hotelCode === undefined) {
            throw new Error('Required parameter hotelCode was null or undefined when calling getLightZones.');
        }
        const room = requestParameters?.room;
        if (room === null || room === undefined) {
            throw new Error('Required parameter room was null or undefined when calling getLightZones.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (basic) required
        localVarHeaders = this.configuration.addCredentialToHeaders('basic', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/${this.configuration.encodeParam({name: "hotelCode", value: hotelCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ctrlapi/1/${this.configuration.encodeParam({name: "room", value: room, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/lights/getzones`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BaseDataResultApiModelOfListOfZoneApiModel>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /{hotelCode}/ctrlapi/1/{room}/lights/getcolor
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getcolor(requestParameters: GetcolorRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BaseDataResultApiModelOfListOfLightColorApiModel>;
    public getcolor(requestParameters: GetcolorRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BaseDataResultApiModelOfListOfLightColorApiModel>>;
    public getcolor(requestParameters: GetcolorRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BaseDataResultApiModelOfListOfLightColorApiModel>>;
    public getcolor(requestParameters: GetcolorRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const hotelCode = requestParameters?.hotelCode;
        if (hotelCode === null || hotelCode === undefined) {
            throw new Error('Required parameter hotelCode was null or undefined when calling getcolor.');
        }
        const room = requestParameters?.room;
        if (room === null || room === undefined) {
            throw new Error('Required parameter room was null or undefined when calling getcolor.');
        }
        const body = requestParameters?.body;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (basic) required
        localVarHeaders = this.configuration.addCredentialToHeaders('basic', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/${this.configuration.encodeParam({name: "hotelCode", value: hotelCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ctrlapi/1/${this.configuration.encodeParam({name: "room", value: room, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/lights/getcolor`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BaseDataResultApiModelOfListOfLightColorApiModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /{hotelCode}/ctrlapi/1/{room}/lights/getdim
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getdim(requestParameters: GetdimRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BaseDataResultApiModelOfListOfLightDimApiModel>;
    public getdim(requestParameters: GetdimRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BaseDataResultApiModelOfListOfLightDimApiModel>>;
    public getdim(requestParameters: GetdimRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BaseDataResultApiModelOfListOfLightDimApiModel>>;
    public getdim(requestParameters: GetdimRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const hotelCode = requestParameters?.hotelCode;
        if (hotelCode === null || hotelCode === undefined) {
            throw new Error('Required parameter hotelCode was null or undefined when calling getdim.');
        }
        const room = requestParameters?.room;
        if (room === null || room === undefined) {
            throw new Error('Required parameter room was null or undefined when calling getdim.');
        }
        const body = requestParameters?.body;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (basic) required
        localVarHeaders = this.configuration.addCredentialToHeaders('basic', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/${this.configuration.encodeParam({name: "hotelCode", value: hotelCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ctrlapi/1/${this.configuration.encodeParam({name: "room", value: room, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/lights/getdim`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BaseDataResultApiModelOfListOfLightDimApiModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /{hotelCode}/ctrlapi/1/{room}/lights/getswitchstate
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getswitchstate(requestParameters: GetswitchstateRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BaseDataResultApiModelOfLightSwitchApiModel>;
    public getswitchstate(requestParameters: GetswitchstateRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BaseDataResultApiModelOfLightSwitchApiModel>>;
    public getswitchstate(requestParameters: GetswitchstateRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BaseDataResultApiModelOfLightSwitchApiModel>>;
    public getswitchstate(requestParameters: GetswitchstateRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const hotelCode = requestParameters?.hotelCode;
        if (hotelCode === null || hotelCode === undefined) {
            throw new Error('Required parameter hotelCode was null or undefined when calling getswitchstate.');
        }
        const room = requestParameters?.room;
        if (room === null || room === undefined) {
            throw new Error('Required parameter room was null or undefined when calling getswitchstate.');
        }
        const body = requestParameters?.body;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (basic) required
        localVarHeaders = this.configuration.addCredentialToHeaders('basic', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/${this.configuration.encodeParam({name: "hotelCode", value: hotelCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ctrlapi/1/${this.configuration.encodeParam({name: "room", value: room, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/lights/getswitchstate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BaseDataResultApiModelOfLightSwitchApiModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /{hotelCode}/ctrlapi/1/{room}/lights/setcolor
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public setcolor(requestParameters: SetcolorRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BaseResultApiModel>;
    public setcolor(requestParameters: SetcolorRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BaseResultApiModel>>;
    public setcolor(requestParameters: SetcolorRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BaseResultApiModel>>;
    public setcolor(requestParameters: SetcolorRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const hotelCode = requestParameters?.hotelCode;
        if (hotelCode === null || hotelCode === undefined) {
            throw new Error('Required parameter hotelCode was null or undefined when calling setcolor.');
        }
        const room = requestParameters?.room;
        if (room === null || room === undefined) {
            throw new Error('Required parameter room was null or undefined when calling setcolor.');
        }
        const lightColorApiModel = requestParameters?.lightColorApiModel;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (basic) required
        localVarHeaders = this.configuration.addCredentialToHeaders('basic', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/${this.configuration.encodeParam({name: "hotelCode", value: hotelCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ctrlapi/1/${this.configuration.encodeParam({name: "room", value: room, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/lights/setcolor`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BaseResultApiModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: lightColorApiModel,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /{hotelCode}/ctrlapi/1/{room}/lights/setdim
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public setdim(requestParameters: SetdimRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BaseResultApiModel>;
    public setdim(requestParameters: SetdimRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BaseResultApiModel>>;
    public setdim(requestParameters: SetdimRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BaseResultApiModel>>;
    public setdim(requestParameters: SetdimRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const hotelCode = requestParameters?.hotelCode;
        if (hotelCode === null || hotelCode === undefined) {
            throw new Error('Required parameter hotelCode was null or undefined when calling setdim.');
        }
        const room = requestParameters?.room;
        if (room === null || room === undefined) {
            throw new Error('Required parameter room was null or undefined when calling setdim.');
        }
        const lightDimApiModel = requestParameters?.lightDimApiModel;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (basic) required
        localVarHeaders = this.configuration.addCredentialToHeaders('basic', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/${this.configuration.encodeParam({name: "hotelCode", value: hotelCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ctrlapi/1/${this.configuration.encodeParam({name: "room", value: room, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/lights/setdim`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BaseResultApiModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: lightDimApiModel,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
